import React from 'react';

import { CustomDatePickerProps, defaultDatePickerConfig } from './custom-date-picker.config';
import DatePicker from 'antd/es/date-picker';

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({ config, ...props }) => {
  const mergedConfig = { ...defaultDatePickerConfig, ...config };

  return <DatePicker showTime={mergedConfig.showTime} format={mergedConfig.format} {...props} />;
};

export default CustomDatePicker;
